import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import { getEventByIdAdmin } from "../../api/plan";
// import { getTicketsByEventId, deleteTicketById } from "../../api/ticket";
import { useForm } from "react-hook-form";
import { jwtDecode } from "jwt-decode";
import TicketTable from "./TicketTable";
import DashboardLayout from "./components/Layout";

const DashboardPage = () => {
  const { "*": wildcard } = useParams();
  const id = wildcard?.split("/")?.[0];

  const navigate = useNavigate();
  const [eventData, setEventData] = useState(null);
  const [tickets, setTickets] = useState([]);
  const [ticketTypeFilter, setTicketTypeFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("success");

  const { register, handleSubmit, control, reset } = useForm();
  const decoded = jwtDecode(localStorage.getItem("auth"));

  useEffect(() => {
    if (decoded?.type !== "event-admin") {
      window.location.replace("/");
    }
  }, [decoded]);

  const fetchEventData = async (id) => {
    const response = await getEventByIdAdmin(id);
    setEventData(response?.data?.data);
  };

  const fetchTickets = async (id) => {
    // const response = await getTicketsByEventId(id);
    // setTickets(response?.data || []);
  };

  useEffect(() => {
    if (id) {
      fetchEventData(id);
      fetchTickets(id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const handleDeleteTicket = async (ticketId) => {
    // await deleteTicketById(ticketId);
    setTickets((prev) => prev.filter((t) => t.id !== ticketId));
  };

  return (
    <DashboardLayout id={id}>
        {id && (
          <main className="flex-1 bg-gray-100">
            <h1 className="text-3xl font-bold mb-4">Tədbir məlumatları</h1>
            <div className="bg-white p-6 rounded-xl shadow">
              <h2 className="text-2xl lg:text-3xl font-extrabold mb-4 leading-tight">
                {eventData?.title}
              </h2>
              <div className="text-xs lg:text-sm text-black-400 mt-6 lg:mt-0">
                🎶 Tarix: {eventData?.eventDate} <br />
                📍 Məkan: {eventData?.place}
              </div>
            </div>

            <h1 className="text-3xl font-bold mb-4 mt-6">📊 Statistika</h1>
            <p className="text-gray-700">
              Burada statistik göstəricilər olacaq. Məsələn: satılmış biletlər,
              gəlir, qonaq sayı və s.
            </p>
            <div className="mt-8 grid grid-cols-2 gap-6">
              <div className="bg-white p-6 rounded-xl shadow">
                <h2 className="text-lg font-semibold">🎟️ Bilet sayı</h2>
                <p className="text-2xl mt-2 font-bold text-green-600">
                  {eventData?.countAllPaidTickets}
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow">
                <h2 className="text-lg font-semibold">💰 Ümumi Gəlir</h2>
                <p className="text-2xl mt-2 font-bold text-blue-600">
                  {eventData?.totalPrice} ₼
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow">
                <h2 className="text-lg font-semibold">📩 Dəvətnamələr</h2>
                <p className="text-2xl mt-2 font-bold text-green-600">
                  {eventData?.countAllInvitations}
                </p>
              </div>
              <div className="bg-white p-6 rounded-xl shadow">
                <h2 className="text-lg font-semibold">👁️ Baxış sayı</h2>
                <p className="text-2xl mt-2 font-bold text-green-600">
                  {eventData?.viewers}
                </p>
              </div>
            </div>
		</main>)}
	</DashboardLayout>
  );
};

export default DashboardPage;
